(function () {
    "use strict";

    // @ngInject
    function NetworkResetPasswordControllerCtor($scope, $injector, $stateParams, UsersManager, NetworkManager,
                                                AppStates, AnalyticsService, PopupMessageService, RedirectService,
                                                WorkspaceFileService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkResetPasswordController';

        this.UsersManager = UsersManager;
        this.NetworkManager = NetworkManager;
        this.AnalyticsService = AnalyticsService;
        this.PopupMessageService = PopupMessageService;
        this.WorkspaceFileService = WorkspaceFileService;
        this.RedirectService = RedirectService;
        this.AppStates = AppStates;

        var self = this;
        this.userId = $stateParams.user_id;
        this.guid = $stateParams.guid;
        this.projectId = $stateParams.project_id;

        this.user = this.UsersManager.newUser();
        this.isSettingPassword = false;

        var analyticsArgs = {
            user_id: this.userId,
            project_id: this.projectId,
            guid: this.guid
        };

        this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.open_reset_password, analyticsArgs);

        this.gotUser = false;
        this.NetworkManager.getNetworkUserByGuid(this.userId, this.guid, this.user).then(function success() {
            self.gotUser = true;
            analyticsArgs.email = self.user.network.email;
            self.hasProfileImage = self.user.network.profile_image ? true : false;
            var defaultImageName = 'yourlogohere.jpg';
            self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.get_user_for_network_create_password_success, analyticsArgs);
        }, function error(resp) {
            self.gotUser = true;
            self.PopupMessageService.showErrorAlert(resp.data.error_message);
            self.goToState(self.AppStates.root_core_login);
            self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.get_user_for_network_reset_password_error, analyticsArgs);
        });

        this.loginParams = {
            loginSuccess: this.resetPwSocialSuccess.bind(this),
            loginError: this.resetPwError.bind(this),
            user: this.user
        };
    }

    Controllers.NetworkResetPasswordController = Class(Controllers.BaseController, {

        constructor: NetworkResetPasswordControllerCtor,

        resetUserPassword: function resetUserPassword(form) {
            if (!form.$valid) {
                return;
            }

            this.isSettingPassword = true;

            var analyticsArgs = {
                user_id: this.userId,
                email: this.user.email
            };

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.reset_password_request, analyticsArgs);

            this.UsersManager.resetUserPassword(this.userId, this.guid, this.newPassword, this.user).then(
                this.resetPwSuccess.bind(this),
                this.resetPwError.bind(this)
            );
        },

        resetPwSuccess: function resetPwSuccess() {

            var analyticsArgs = {
                user_id: this.userId,
                email: this.user.email
            };

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_reset_password_success, analyticsArgs);

            this.$state.go(this.AppStates.root_core_login);
        },

        resetPwSocialSuccess: function resetPwSocialSuccess() {

            var analyticsArgs = {
                user_id: this.userId,
                email: this.user.email
            };

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_reset_password_success, analyticsArgs);

            this.RedirectService.networkRedirect(this.user);
        },

        resetPwError: function resetPwError(resp) {
            this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.network_reset_password, resp);
            this.errorSettingPassword = resp.data.error_message;

            this.isSettingPassword = false;
        }
    });
}());
